import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { View } from 'react-native';
import { translate } from '../../../services/translate';
import FormInput from '../../../components/FormInput';
import BasicModal from '../../../components/BasicModal';
import { HexColorPicker } from 'react-colorful';
import Toast from 'react-native-toast-message';
import { cameraService } from '../../../services/central-api/cameras';

interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: Dispatch<SetStateAction<boolean>>;
    onClose: () => void;
    cameraTag?: CameraTag;
}

export default function CameraTagModal({ onClose, cameraTag, isModalVisible, setModalVisible }: ModalProps) {

    const [name, setName] = useState('');
    const [color, setColor] = useState('#aabbcc');
    const [isLoading, setIsLoading] = useState<boolean>(false);

    function isNameInvalid(value: string) {
        return value == '';
    }

    function isFormValid() {
        return !isNameInvalid(name);
    }

    function clearValues() {
        setName('');
    }

    useEffect(() => {
        if (isModalVisible) {
            setColor(`#${Math.floor(Math.random() * 0x1000000).toString(16).padStart(6, '0')}`);
        }
    }, [isModalVisible]);

    useEffect(() => {
        if (!cameraTag) {
            return;
        }
        setName(cameraTag.name);
        setColor(cameraTag.color);
    }, [cameraTag]);

    async function formSubmit() {
        setIsLoading(true);
        try {
            if (cameraTag?.id) {
                await cameraService.updateCameraTag({
                    id: cameraTag.id,
                    name: name,
                    color: color
                });
            } else {
                await cameraService.createCameraTag({
                    name: name,
                    color: color,
                });
            }

            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
        } catch (err) {
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        } finally {
            setIsLoading(false);
            clearValues();
            onClose();
        }
    }

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            title={translate('cameraTag')}
            width='small'
            mobileHeight='fit'
            cancelButton={{
                onClick: () => {
                    onClose(); clearValues();
                }
            }}
            primaryButton={{
                text: translate('save'),
                onClick: formSubmit,
                disabled: !isFormValid() || isLoading,
            }}
            disableScrollView={true}
        >
            <FormInput
                label={translate('name')}
                placeholder={translate('name')}
                value={name}
                onChangeText={setName}
                invalid={isNameInvalid}
            />
            <View>
                <HexColorPicker color={color} onChange={setColor} />
            </View>

        </BasicModal>
    );
}
